var ui_templates = require("ui-templates");
var MasterTemplate = ui_templates.Master;
var PackageSidebar = require('./package__sidebar.js');

class PackageMasterTemplate extends MasterTemplate {
    addSidebar(pos, width, theme){
        return new PackageSidebar({
            target: $(".js-editor__master__content", this.$el),
            prepend: true,
            fields: {
                'position': pos,
                'width': width,
                'theme': theme
            }
        });
    }
}

module.exports = PackageMasterTemplate;
